import { z } from 'zod';

export const referralsPostRequestSchema = z.object({ company: z.string(), referral: z.string() });
